import { useCallback, useEffect, useState } from "react";
import { prefersReducedMotion } from "../../motion";

// `reveal` (0 to 1) is how far the hero has moved from "today" to "with
// AVRAH". It plays over `ms`, eased by `ease`, and once played it stays
// played; `played` says whether it has been asked to. It plays only when
// `play` asks for it, from the hero's button; never by itself, however long
// the page is left or however far it scrolls. For those who ask for less
// motion it shows whole at once.
export default function useReveal({ ms, ease }) {
  if (!(ms > 0)) throw new Error(`useReveal: the reveal plays over a number of milliseconds, not ${ms}`);
  const [played, setPlayed] = useState(false);
  const [reveal, setReveal] = useState(0);

  useEffect(() => {
    if (!played) return undefined;
    if (prefersReducedMotion()) {
      setReveal(1);
      return undefined;
    }
    const start = performance.now();
    let frame = requestAnimationFrame(function tick(now) {
      const t = Math.min(1, (now - start) / ms);
      setReveal(ease(t));
      if (t < 1) frame = requestAnimationFrame(tick);
    });
    return () => cancelAnimationFrame(frame);
  }, [played, ms, ease]);

  const play = useCallback(() => setPlayed(true), []);
  return { reveal, play, played };
}
